<div class="card card-body">
    <div style="position: relative; padding-bottom: 62.5%; height: 0;">
        <iframe [src]="safeSrc" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen
            style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe>
    </div>
</div>
<div class="col-12 mt-2 mb-2 text-end">
    <button class="btn btn-primary btn-sm" type="button" (click)="forceCloseModal()">
        {{ "PROPERTIES.Zatvori" | translate }}
    </button>
</div>